/** Every POS shortcut in one list: the hotkey hook reads keys from here and the shortcuts sheet renders it. */
export const SHORTCUTS = {
  search: { keys: ['F2', '/'], label: 'Search products' },
  customer: { keys: ['F3'], label: 'Choose customer' },
  discount: { keys: ['F4'], label: 'Order discount' },
  hold: { keys: ['F6'], label: 'Hold order' },
  held: { keys: ['F7'], label: 'Held orders' },
  pay: { keys: ['F9'], label: 'Pay' },
  clear: { keys: ['Shift+Delete'], label: 'Clear cart' },
  help: { keys: ['?'], label: 'Keyboard shortcuts' },
  qtyUp: { keys: ['+'], label: 'Last item quantity +1' },
  qtyDown: { keys: ['-'], label: 'Last item quantity −1' },
} as const

export type ShortcutId = keyof typeof SHORTCUTS
